module.exports = __webpack_public_path__ + "static/media/me.d45d13ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/me.jpg
// module id = 62
// module chunks = 0